<script>
	// From Lucide
	import { ChevronDown } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ChevronDown class={iconClass} />
